/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import axios from "axios"
import {EncryptionSVC, waitForDream} from "../index.wasm";

class AuthService {
    setToken(token){
        localStorage.setItem("token", token)
    }

    getToken(){
        return localStorage.getItem("token")
    }

    parseJwt (token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };

    getParsedToken(){
        return this.parseJwt(this.getToken())
    }

    getUserID(){
        if(!this.hasToken()){
            return ""
        }

        return this.getParsedToken().sub;
    }

    hasToken(){
        let token = this.getToken();
        if(!token){
            return false
        }

        try{
            let info = this.parseJwt(token)
            let expiresAt = new Date(info.exp * 1000).getTime()
            return expiresAt > this.currentTime()
        }catch (e){
            return false
        }
    }

    removeToken(){
        localStorage.removeItem("token")
    }

    currentTime(){
        return (new Date()).getTime()
    }

    clearPublicKeys(){
        localStorage.removeItem("pKey")
    }

    async encryptIfNeeded(config) {
        if(!config.encrypt){
            return
        }

        let rawData = localStorage.getItem("pKey")
        if(rawData){
            try{
                rawData = JSON.parse(rawData)
                if(rawData.expires < this.currentTime()){
                    rawData = null
                }
            }catch (e){
                console.error(e.message)
                console.error(e.stack)
                rawData = null
            }

            if(rawData) {
                let str = JSON.stringify(config.data)
                let result = await EncryptionSVC.encrypt(str, rawData.key)
                if(!result){
                    return
                }

                delete config.encrypt;
                config.ignore = true
                config.originalData = config.data
                config.data = result

                config.headers['Content-Type'] = 'application/json'
                config.headers['Key-ID'] = rawData.id;
                return
            }
        }

        let res = await axios.get(`/v1/user/public-key`, {ignore: true});
        if(res.status == 200) {
            localStorage.setItem("pKey", JSON.stringify(res.data))
            return await this.encryptIfNeeded(config)
        }

        return
    }


}

export default AuthService;
